<div class="root-container">
  <page-title text="Your Profile" bi_icon="bi-person-fill" />
  @if (!loading()) {
    <div class="content">
      <div 
      class="button-edit" 
      (click)="toggleEditing()">
      <i class="bi bi-pencil-square button-edit"></i> Edit</div>

      <div class="header">
        <div (click)="upload_modal.onShow()" class="profile-img">
          <i class="bi bi-x-lg remove-photo" [ngClass]="{ 'd-none': !user().image}" (click)="confirmRemovePhoto($event)"></i>
          <img [src]="user().image ?? 'assets/images/defaults/default_user.png'" alt="user profile">
          <span class="pen"><i class="bi bi-pen"></i></span>
        </div>
        <p class="name">{{ user().first_name }} {{ user().middle_name ?? '' }} {{ user().last_name }}</p>
        <p class="email">{{ user().email }}</p>
      </div>

      <div class="body">
        <div class="section-title">
          <span>Personal Information</span>
        </div>

        <personal-information 
        [form]="personal_information_form" 
        [editing]="editing()" />

        @if(role == "fae") {
          <div class="section-title">
            <span>FAE Details</span>
          </div>
          <fae-details 
          #fae_form
          [editing]="editing()"
          [user]="user()"
          />
        }

        @if (role == "ts" || role == 'tsm') {
          <div class="section-title">
            <span>TS/M Details</span>
          </div>
          <tsm-details
          #tsm_form
          [user]="user()"
          [editing]="editing()"
          ></tsm-details>
        }
      </div>

      @if(editing()) {
        <div class="footer">
          <button-component 
          text="Save" 
          type="primary" 
          (click)="save()"
          [isLoading]="saving()"
          [disabled]="personal_information_form.invalid || fae_form()?.getForm()?.invalid || isProcessingImage()"
          />
          <button-component 
          text="Cancel" 
          type="secondary" 
          (click)="toggleEditing()"
          [disabled]="isProcessingImage()" />
        </div>
      }

      <profile-image-upload #upload_modal (onSubmit)="updateProfileImage($event)" />
    </div>
  } @else {
    <div class="text-center">
      <spinner />
    </div>
  }

  <div class="content qr-section">
    <div class="circle"></div>
    <div class="inner-circle">
      <img 
      src="/assets/images/common/qr-image.png"
      alt="qr-icon"
      >
    </div>

    <div class="qr-actions">
      <qr-component
      #qr_component
      [qrdata]="generateQRData()"
      [email]="user().email"
      [name]="user().first_name + ' ' + user().last_name"
      [withPreview]="true"
      ></qr-component>
      <button-component 
        text="Download Your QR Code"
        type="primary"
        (click)="qr_component.downloadQRCode()"
        bi_icon="bi-download"
        ></button-component>
    </div>
    <p>This QR code directs your client to the HPI Marketplace Registration Form with your name as their sales representative.</p>
  </div>
</div>
